import { inject, Injectable } from '@angular/core';
import { SessionStorageService } from '../../../../core/services/session-storage/session-storage.service';
import { DsuManagerAssessmenModel } from '../dsu-manager-assessment-models/dsu-manager-assessment.models';
import { environment } from '../../../../../environments/environment';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';

@Injectable({
  providedIn: 'root'
})
export class DsuManagerAssessmentService {

  private sessionStorageService = inject(SessionStorageService);

  constructor() { }

  async saveDsuManagerAssessment(dsuAssessment: DsuManagerAssessmenModel) {

    const API_URL: string = environment.baseUrl + environment.apis.savedsumanagerAssessment;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: dsuAssessment.toString()
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async viewDsuManagerAssessment(viewid: number, status: string) {

    const API_URL: string = environment.baseUrl + environment.apis.viewdsumanagerAssessment;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        onboarding_id: viewid,
        status: this.sessionStorageService.getCurrentUserRole() == 'DSU Manager' ? 'DSU Manager Approval' : status,
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async savelodgmentDsuManagerAssessment(dsuAssessment: DsuManagerAssessmenModel) {

    const API_URL: string = environment.baseUrl + environment.apis.savelodgmentDsuManagerAssessment;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: dsuAssessment.lodgetoString()
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }
}
